var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvgLavagens(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "106px",
    viewBox: "0 0 74 106",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets_Board",
    transform: "translate(-3007.000000, -419.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(3010.000000, 422.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1370474,0 C13.7128766,0 11.8106695,4.20383114 10.7689709,9.40202121 L6.91918788,27.7086358 L61.2686762,27.7086358 L57.4189622,9.40202121 C56.2866812,4.20383114 54.4297211,0 46.0055503,0 L22.1370474,0 Z",
    id: "Vector",
    stroke: "",
    strokeWidth: 5.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 27.663390)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.87385241,
    y1: 17.5382637,
    x2: 3.4770094,
    y2: 17.5382637,
    id: "Vector",
    stroke: "",
    strokeWidth: 5.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.6201837,
    y1: 17.5382637,
    x2: 61.2233407,
    y2: 17.5382637,
    id: "Vector",
    stroke: "",
    strokeWidth: 5.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.6675384,
    y1: 41.2691318,
    x2: 23.8580675,
    y2: 41.2691318,
    id: "Vector",
    stroke: "",
    strokeWidth: 5.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.2391256,
    y1: 41.2691318,
    x2: 54.4296546,
    y2: 41.2691318,
    id: "Vector",
    stroke: "",
    strokeWidth: 6.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0874725,65 L54.701391,65 C51.0328006,65 50.5346329,63.4178538 49.8552643,61.5193844 L49.1758542,59.4855307 C48.2247382,56.7282297 47.5906942,54.8296279 42.69924,54.8296279 L25.3074225,54.8296279 C20.4159684,54.8296279 19.6912728,56.9542381 18.8307392,59.4855307 L18.1513983,61.5193844 C17.5173209,63.4630555 17.0190841,65 13.3052024,65 L6.91912039,65 C2.84290888,65 -0.372719422,61.5646081 0.0349017566,57.5868626 L1.93712557,36.9296738 C2.43532921,31.8218869 3.38641512,27.66339 12.3087896,27.66339 L55.6525375,27.66339 C64.5749119,27.66339 65.5259974,31.8218869 66.0242011,36.9296738 L67.9717604,57.5868626 C68.3340903,61.5646081 65.163684,65 61.0874725,65 Z",
    id: "Vector",
    stroke: "",
    strokeWidth: 5.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(5.000000, 0.000000)",
    stroke: "",
    strokeWidth: 4.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0678805,9.99739769 C47.0961401,8.65785644 47.3920011,7.60083455 47.7957101,6.57234996 C48.6449408,4.40950737 49.8670255,2.45184803 51.2289665,0.577517626 C51.7797409,-0.181004026 52.5156447,-0.194987307 53.0543078,0.551263302 C54.5183295,2.5794098 55.8404764,4.69202672 56.6845165,7.05891107 C57.1470516,8.35593172 57.417825,9.67406999 57.0977414,11.0635515 C56.5599434,13.3990448 54.5093902,15.1015806 52.175664,15.1081633 C49.8422262,15.1147078 47.7559159,13.4275821 47.2351314,11.0952279 C47.1385296,10.6631731 47.1004656,10.2182765 47.0678805,9.99739769 Z",
    id: "Stroke-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,9.99739769 C0.0282596277,8.65785644 0.324120627,7.60083455 0.727829594,6.57234996 C1.57706024,4.40950737 2.79943332,2.45184803 4.16108599,0.577517626 C4.71186037,-0.181004026 5.4480525,-0.194987307 5.98642725,0.551263302 C7.45044898,2.5794098 8.77259584,4.69202672 9.61663595,7.05891107 C10.0791711,8.35593172 10.3499444,9.67406999 10.0298609,11.0635515 C9.49206289,13.3990448 7.44150971,15.1015806 5.10778352,15.1081633 C2.77434569,15.1147078 0.688323788,13.4275821 0.167250858,11.0952279 C0.0706490691,10.6631731 0.0325850809,10.2182765 0,9.99739769 Z",
    id: "Stroke-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7110645,16.5843792 C21.7494169,14.7648404 22.1513956,13.3285577 22.6998631,11.9310857 C23.8533173,8.99316982 25.514003,6.33377806 27.3638551,3.78710868 C28.1124469,2.75662648 29.1122033,2.73779186 29.8437816,3.75172242 C31.832625,6.50699952 33.6288416,9.37699661 34.775375,12.5922951 C35.4037192,14.3544739 35.7716711,16.14519 35.3368189,18.0329329 C34.6061056,21.2057109 31.8205138,23.5186597 28.6502449,23.5275318 C25.4799761,23.5363528 22.6459391,21.2445216 21.9380066,18.0757389 C21.8070896,17.4887265 21.7554725,16.8845917 21.7110645,16.5843792 Z",
    id: "Stroke-8"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgLavagens);
export default __webpack_public_path__ + "static/media/svg_lavagens.227c374fbe6effd8d3c6329095bd832e.svg";
export { ForwardRef as ReactComponent };